import { Component, input } from "@angular/core";
import { FieldTree, FormField } from "@angular/forms/signals";
import { EvTooltipModule } from "ev-tooltip";
import { FacilitiesTypeModel, FacilitiesTypesFilterModel } from "./search-filter-facilities.model";

@Component({
    selector: "search-filter-facilities",
    imports: [FormField, EvTooltipModule],
    templateUrl: "./search-filter-facilities.component.html",
    styleUrl: "./search-filter-facilities.component.scss",
})
export class SearchFilterFacilitiesComponent {
    filterForm = input.required<FieldTree<FacilitiesTypesFilterModel>>();

    showTooltip = false;

    facilitiesTooltip = {
        show: false,
        header: "",
        sections: [
            {
                paragraphs: [
                    "Dekningsgraden av denne informasjonen kan variere. Vi har for eksempel informasjon om at det finnes balkong på en rekke boliger, men det betyr ikke at de resterende boligene mangler balkong. Velger du filter for balkong vil det altså være balkong på alle i utvalget, men det vil helt sikkert være balkong på andre boliger også.",
                ],
            },
        ],
        width: 300,
    };

    toggleExpanded(): void {
        this.filterForm().expanded().value.set(!this.filterForm().expanded().value());
    }

    toggleSelectedFacilityType(facilityType: FacilitiesTypeModel): void {
        const current = this.filterForm().facilitiesTypes().value();
        this.filterForm()
            .facilitiesTypes()
            .value.set(current.map((e) => (e.index === facilityType.index ? { ...e, selected: !e.selected } : e)));
    }

    selectAllFacilityTypes(): void {
        if (this.checkIfAllSelected()) {
            this.filterForm().facilitiesTypes().value.update((facilitiesTypes: FacilitiesTypeModel[]) => {
                return facilitiesTypes.map((facilityType) => {
                    return {
                        ...facilityType,
                        selected: false,
                    };
                });
            });
        } else {
            this.filterForm().facilitiesTypes().value.update((facilitiesTypes: FacilitiesTypeModel[]) => {
                return facilitiesTypes.map((facilityType) => {
                    return {
                        ...facilityType,
                        selected: true,
                    };
                });
            });
        }
    }

    private checkIfAllSelected(): boolean {
        return this.filterForm()
            .facilitiesTypes()
            .value()
            .every((facilityType) => facilityType.selected);
    }
}
